import React from 'react';
import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import { buildColorMap, orderTypes, typeKey, typeLabel } from '../../utils/categoricalColors';
import { formatDecimal1, formatInt, formatPercent1 } from '../../utils/numberFormat';

/**
 * Barre per tipo, ordinate per pagine decrescenti.
 * L'ordine cambia, i colori no: la mappa si costruisce sull'ordine categoriale fisso, non su questa
 * classifica.
 */
const UsageTypeBars = ({ rows }) => {
  const colorByType = buildColorMap(orderTypes(rows).map((row) => typeKey(row.codexTypeId)));
  const massimo = Math.max(...rows.map((row) => row.pages), 1);

  if (!rows.length) {
    return <Typography color="text.secondary">Nessuna pagina elaborata nel periodo selezionato</Typography>;
  }

  return (
    <Stack spacing={2}>
      {rows.map((row) => {
        const key = typeKey(row.codexTypeId);
        return (
          <Box key={key}>
            <Stack direction="row" alignItems="baseline" spacing={1}>
              <Typography variant="body2" sx={{ fontWeight: 600, flexGrow: 1 }}>
                {typeLabel(row)}
              </Typography>
              <Typography variant="body2" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                {formatInt(row.pages)} pagine
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {formatPercent1(row.sharePercent)}
              </Typography>
            </Stack>

            <LinearProgress
              variant="determinate"
              value={(row.pages / massimo) * 100}
              sx={{
                height: 8,
                borderRadius: 1,
                my: 0.5,
                '& .MuiLinearProgress-bar': { backgroundColor: colorByType.get(key) },
              }}
            />

            <Typography variant="caption" color="text.secondary">
              {formatInt(row.documents)} documenti · {formatDecimal1(row.avgPagesPerDocument)} pagine in media
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
};

export default UsageTypeBars;
